import { ReactElement } from 'react'
import styled, { css } from 'styled-components'
import { TypographyElement, TYPOGRAPHY_LINE_HEIGHT_CSS_VAR } from '../Typography/Typography'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const TextBlockIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TextBlockStyle = css`
  display: flex;
  align-items: start;
  gap: var(--text-block-gap);

  &.fit-stretch {
    > ${TypographyElement} {
      flex-grow: 1;
    }
  }

  &.fit-auto {
    > ${TypographyElement} {
      flex-grow: 0;
    }
  }

  &.align-start {
    justify-content: start;
  }

  &.align-center {
    justify-content: center;
  }

  &.align-end {
    justify-content: end;
  }

  ${mediaQueryUp.tablet} {
    &.align-on-desktop-start {
      justify-content: start;
    }

    &.align-on-desktop-center {
      justify-content: center;
    }

    &.align-on-desktop-end {
      justify-content: end;
    }
  }

  > ${TextBlockIcon} {
    height: var(${TYPOGRAPHY_LINE_HEIGHT_CSS_VAR});
  }
`

export type TextBlockProps = {
  fit?: 'stretch' | 'auto'
  startIcon?: ReactElement
  endIcon?: ReactElement
  as?: never
  forwardedAs?: never
}
// Q: Why do we need all those variants of the props?
// A: To enforce existence of at least one icon in the text block.
// A text block without any icons is technically a typography element with just an extra div inside.
